<template>
  <v-card class="secondary menu-button primary--shadow">
    <v-card-text>
      <v-list color="secondary">
        <v-list-item-group mandatory>
          <v-list-item v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.DATOS_GENERALES)">
            <v-list-item-icon><v-icon color="primary">mdi-account</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Datos generales </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.REFERENCIAS)">
            <v-list-item-icon><v-icon color="primary">mdi-account-multiple</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Referencias </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.DOCUMENTOS)">
            <v-list-item-icon><v-icon color="primary">mdi-folder</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Documentos </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.DESARROLLO_ELEMENTO)"
            v-if="estatus < 8 && perfil !== PERFILES['Enlace C3']"
          >
            <v-list-item-icon><v-icon color="primary">mdi-shield-account</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Desarrollo del elemento </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.TRAMITES_ADMINISTRATIVOS)"
            v-if="estatus < 7"
          >
            <v-list-item-icon><v-icon color="primary">mdi-account-alert</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Trámites administrativos </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.PUESTO_DEPENDENCIA)" v-if="estatus < 7">
            <v-list-item-icon><v-icon color="primary">mdi-domain</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Puesto y dependencia </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="estatus < 7 && hasAccessToFeature(perfil, FEATURES.VISUALIZACION_RESULTADOS_C3)"
            v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.RESULTADOS_C3)"
          >
            <v-list-item-icon><v-icon color="primary">mdi-information</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Resultados C3 </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.LINEA_TIEMPO)" v-if="estatus < 7">
            <v-list-item-icon><v-icon color="primary">mdi-chart-timeline-variant</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Línea del tiempo </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.MEDIA_FILIACION)"
            v-if="
              estatus < 7 &&
              perfil !== PERFILES['ENLACE C3_ADMINISTRADOR'] &&
              perfil !== PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'] &&
              perfil !== PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE'] &&
              perfil !== PERFILES['ENLACE C3']
            "
          >
            <v-list-item-icon><v-icon color="primary">mdi-head-alert</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Media filiación</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.EVALUACIONES)"
            v-if="perfil == PERFILES['Policia']"
          >
            <v-list-item-icon><v-icon color="primary">mdi-file-document-edit</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Evaluaciones </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.CARRERA_POLICIAL)"
            v-if="
              (estatus < 7 &&
                perfil !== PERFILES['ENLACE C3_ADMINISTRADOR'] &&
                perfil !== PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'] &&
                perfil !== PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE'] &&
                perfil !== PERFILES['ENLACE C3']) ||
              perfil === PERFILES['Policia']
            "
          >
            <v-list-item-icon><v-icon color="primary">mdi-account-star</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Carrera policial </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-on:click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.TRAYECTORIA_LABORAL)"
            v-if="
              perfil === PERFILES['Enlace C3'] ||
              perfil === PERFILES['ENLACE C3_ADMINISTRADOR'] ||
              perfil === PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'] ||
              perfil === PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE']
            "
          >
            <v-list-item-icon><v-icon color="primary">mdi-briefcase</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> Trayectoria laboral </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="perfil === PERFILES['Administrador IPH+'] || perfil === PERFILES['ARMERIA_PERSONAL LOC']"
            @click="SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.LOCS)"
          >
            <v-list-item-icon><v-icon color="primary">mdi-certificate</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="primary--text"> LOCs </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import { PERFILES, FEATURES } from '@/perfiles.js'
import { MENU_EXPEDIENTE_PERSONAL } from '@/menuExpedientePersonal.js'

export default {
  props: {
    estatus: {
      type: Number,
    },
  },
  data() {
    return {
      PERFILES,
      FEATURES,
      MENU_EXPEDIENTE_PERSONAL,
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),
  },

  methods: {
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),
  },
}
</script>
